
import { Vue, Component, Prop, Watch } from 'vue-property-decorator'
import { CourseModule } from '../../store/modules/course'
import { formatDate } from '../../utils/publish'
  @Component
export default class Message extends Vue {
    @Prop() recordPop: boolean
    @Prop() messageTemplate: any

    tableHeight: number = window.innerHeight - 200
    tableData: any = []
    messageRecordTitle: string = ''
    messageTemplateId: string = ''
    getRecordPhone: string = ''
    page: number = 1
    size: number = 10
    total_count: number = 0


    @Watch('recordPop')
    getPopRecord(newVal, oldVal) {
      if(newVal) {
        this.getRecordList()
      }
    }
    mounted() {

    }
    handleCurrentChange(val) {
      this.page = val
      this.getRecordList()
    }
    async getRecordList() {
      const res: any = await CourseModule.getRecordList({ 'template_id': this.messageTemplateId, phone: this.getRecordPhone, name: this.messageRecordTitle, page: this.page, size: this.size })
      if(res.code === 200) {
        this.tableData = res.data.list
        this.total_count = res.data.total
      }
    }

    changeRecordTitle(val) {
      this.messageRecordTitle = val
      this.page = 1
      this.getRecordList()
    }
    changeMessageTemplate(val) {
      this.page = 1
      this.getRecordList()
    }
    getDate(time, type) {
      return formatDate(time, type)
    }
    changePhone(val) {
      this.page = 1
      this.getRecordList()
    } 
    async resendMessage(val) {
      let data = {
        id: val.id
      }
      const res: any = await CourseModule.putRecordList(data)
      if(res.code === 200) {
        this.$message({
          type: 'success',
          message: '发送成功!'
        })
        this.page = 1
        this.getRecordList()
      } else {
        this.$message.error(res.message)
      }
    }
    close(){
      this.$emit('close-record', {type: false})
    }
}
